import createReducer from "../../reducers/createReducer";
import {
  ONBOARD_VENDOR_INFO_LOADING,
  ONBOARD_VENDOR_INFO_SUCCESS,
  ONBOARD_VENDOR_INFO_ERROR,
  ONBOARD_VENDOR_VERIFY_LOADING,
  ONBOARD_VENDOR_VERIFY_SUCCESS,
  ONBOARD_VENDOR_VERIFY_ERROR,
} from "./types";

let initialState = {
  loading: false,
  onBoardVendorInfo: null,
  success: null,
  error: null,
};

export const onBoardVendorReducer = createReducer(initialState, {
  [ONBOARD_VENDOR_INFO_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      onBoardVendorInfo: null,
      success: null,
      error: null,
    });
  },
  [ONBOARD_VENDOR_INFO_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardVendorInfo: action.payload,
      error: null,
    });
  },
  [ONBOARD_VENDOR_INFO_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      onBoardVendorInfo: null,
      error: action.payload,
    });
  },
  [ONBOARD_VENDOR_VERIFY_LOADING](state, action) {
    return Object.assign({}, state, {
      loading: true,
      success: null,
      error: null,
    });
  },
  [ONBOARD_VENDOR_VERIFY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [ONBOARD_VENDOR_VERIFY_ERROR](state, action) {
    return Object.assign({}, state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
});
